import React from "react";
import ReactGA from "react-ga4";
import {Link} from 'react-router-dom';
// import FooterLinks from './footer-links/footer-links.js';
import HelpAndCurrency from './help-and-currency.js';
import AboutLinks from './footer-links/about-links.js';
import * as Utilities from './utilities.js';

export default class About extends React.Component {
  componentDidMount() {
	  var ga = Utilities.gaInitialize(ReactGA);
	  Utilities.gaPageView(ga, "msa_page_view", "/about", "About Us");
  }
  render(){

    return(
      <div>

        <div className='content-area-container'>
          <div className="replacement_parts_header">
            <h1>About Us</h1>
          </div>
          <div className="about-para"><p>Specializing in Compressed Air & Vacuum Systems, for Medical, Dental, Laboratory & Industrial Applications since 2005.

          We are committed to offering top-quality customer service and competitive pricing for the following product lines:</p>
        </div>

          <div className="about-subhead">
            <ul>
              <li><b>AeroVac</b> - Replacement Parts</li>
              <li><b>Atlas Copco</b> - Replacement Parts</li>
              <li><b>Becker</b> - Vacuum Pumps, Parts</li>
              <li><b>Busch</b> - Vacuum Pumps, Parts</li>
              <li><b>Champion</b> - Air Compressors</li>
              <li><b>Chemetron</b> - Medical Gas Equipment</li>
              <li><b>Chicago Pneumatic</b> - Air Compressors</li>
              <li><b>Curtis</b> - Air Compressors</li>
              <li><b><a href="/category?id=267">Deltech</a></b> - Air Dryers, Filters</li>
              <li><b>Dominick Hunter</b> - Air Dryers, Filters</li>
			  <li><b>Enmet</b> - Monitors</li>
              <li><b>GAST</b> - Air Compressors, Vacuum Pumps, Parts</li>
              <li><b>Gentec</b> - Hoses, Valves, Parts</li>
              <li><b>Global Vac</b> - Liquid Ring Vacuum Equipment</li>
              <li><b><a href="/category?id=274">Hankison</a></b> - Air Dryers, Filters, Parts</li>
              <li><b>Ingersoll Rand</b> - Air Compressors, Parts</li>
              <li><b>International Control Products (ICP)</b> - NFPA & Industrial Control Panels</li>
              <li><b>Kaeser</b> - Air Compressors, Parts</li>
              <li><b>Kobelco</b> - Air Compressors, Parts</li>
              <li><b>Metalflex</b> - Flex Connectors</li>
              <li><b><a href="/category?id=309">Nano</a></b> - Replacement Parts</li>
              <li><b>Numatics</b> - Replacement Parts</li>
              <li><b>Oxequip</b> - Medical Gas Equipment</li>
              <li><b>Penway</b> - Air Receivers</li>
              <li><b><a href="/category?id=306">Powerex</a></b> - Air Compressors, Vacuum Pumps, Parts</li>
              <li><b>Quincy</b> - Air Compressors, Vacuum Pumps, Parts</li>
              <li><b><a href="/category?id=223">RamVac</a></b> - Dental Air Compressors & Vacuum Pumps, Parts</li>
              <li><b>Rietschle</b> - Vacuum Pumps, Parts</li>
              <li><b>SiHi</b> - Liquid Ring Pumps</li>
              <li><b><a href="/category?id=316">Solberg</a></b> - Filtration</li>
              <li><b><a href="/category?id=231">Solmetex</a></b> - Amalgam Separators, Parts</li>
              <li><b>Sullair</b> - Air Compressors, Parts</li>
              <li><b><a href="/category?id=255">TechWest</a></b> - Dental Air Compressors & Vacuum Pumps, Parts</li>
              <li><b>Travaini</b> - Liquid Ring Vacuum Pumps</li>
              <li><b><a href="/category?id=247">Trident</a></b> - Compressors, Vacuum Pumps, & Parts</li>
              <li><b>Ultra Air</b> - Replacement Parts</li>
              <li><b><a href="/category?id=247">Trident</a></b> - Desiccant Dryers, Filters, Parts</li>
              <li><b>Watts</b> - Filters, Regulators, Lubricators</li>
              <li><b>Zander</b> - Air Dryers, Filters, Parts</li>
              <li><b><a href="/category?id=233">Zeks</a></b> - Drains, Elements, Parts</li>
            </ul>

          </div>


          <div className="FooterLinks1">
            <HelpAndCurrency />

          </div>
          <div className="FooterLinks2">
            <AboutLinks />
          </div>
              </div>
              <div className="about-footer">
                <div className="terms">
                  <p><a href="/terms" rel="noopener noreferrer">Terms of Use</a> | <a href="/privacy" rel="noopener noreferrer">Privacy Policy</a></p>
                </div>
			<div className="copyright">
				<p>&copy; {new Date().getFullYear()} - MS Air, Inc. | <Link to="/">Home</Link></p>
			</div>
            </div>



    </div>
    )
  }
}
